import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=2a677346"
import script from "./DownloadBtn.vue?vue&type=script&lang=js"
export * from "./DownloadBtn.vue?vue&type=script&lang=js"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=2a677346&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a677346')) {
      api.createRecord('2a677346', component.options)
    } else {
      api.reload('2a677346', component.options)
    }
    module.hot.accept("./DownloadBtn.vue?vue&type=template&id=2a677346", function () {
      api.rerender('2a677346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/DownloadBtn.vue"
export default component.exports